// extracted by mini-css-extract-plugin
export default {"openlayerMap":"Map_openlayerMap__2sdsn","btn":"Map_btn__ZrR3B","mapName":"Map_mapName__W8k36"};